import React from 'react';
import './style.scss';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';

class CuiAutoText extends React.PureComponent {
  state = {
    value: '',
    suggestions: []
  }

  getSuggestionValue = suggestion => {
    this.props.handleSelectedItem(suggestion);
    return suggestion.PROVINCE_NAME;
  }

  renderSuggestion = suggestion => (
    <div>
      {suggestion.PROVINCE_NAME}
    </div>
  );

  getSuggestions = value => {
    if (value === "") {
      return this.props.listSuggest;
    }

    const inputValue = value.trim().toLowerCase();
    const inputLength = inputValue.length;
   
    const list = inputLength === 0 ? [] : this.props.listSuggest.filter(lang =>
      lang.PROVINCE_NAME.toLowerCase().slice(0, inputLength) === inputValue
    );
    return list;
  };

  shouldRenderSuggestions = () => {
    return true;
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
    this.props.handleValue(newValue);
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const { value, suggestions } = this.state;
    const { customClass, customTitle, placeholder, title, errorMsg } = this.props;

    const inputProps = {
      placeholder,
      value,
      onChange: this.onChange
    };
    
    return (
      <>
        <div className={`auto-text ${customClass || ''} ${errorMsg && 'border-alert'}`}>
          {title && <div className={`auto-text__title ${customTitle || ''}`}>{title}</div>}
          <Autosuggest
            suggestions={suggestions}
            inputProps={inputProps}
            onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
            onSuggestionsClearRequested={this.onSuggestionsClearRequested}
            getSuggestionValue={this.getSuggestionValue}
            renderSuggestion={this.renderSuggestion}
            shouldRenderSuggestions={this.shouldRenderSuggestions}
          />
        </div>
        {errorMsg &&
          <div className="err-msg">{errorMsg}</div>
        }
      </>
    );
  }
}

CuiAutoText.propTypes = {
  listSuggest: PropTypes.array,
  handleSelectedItem: PropTypes.func,
  handleValue: PropTypes.func,
  title: PropTypes.string,
};

CuiAutoText.defaultProps = {
  listSuggest: [],
  handleSelectedItem: () => {},
  handleValue: () => {},
  title: '',
};

export default CuiAutoText;
